module.exports = __webpack_public_path__ + "static/media/heatindex_chart_2.9e61d0fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/WindHeat/heatindex_chart_2.png
// module id = 2524
// module chunks = 0